import { AdditionalInfo } from "./AdditionalInfo";
import { SubmitClaim } from "./SubmitClaim";

export default {
  AdditionalInfo,
  SubmitClaim,
};
